module.exports = __webpack_public_path__ + "img/icon-checkin-change.96d2eee4.png";